module.exports = __webpack_public_path__ + "static/media/double2.7ce71678.svg";